import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Link14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.5657 2.93416C12.4444 3.81284 12.4444 5.23746 11.5657 6.11614L11.2627 6.41918L12.3234 7.47984L12.6264 7.1768C14.0909 5.71233 14.0909 3.33796 12.6264 1.8735C11.1619 0.40903 8.78757 0.40903 7.32311 1.8735L5.90889 3.28771C4.44443 4.75218 4.44443 7.12654 5.90889 8.59101L6.96955 7.53035C6.09087 6.65167 6.09087 5.22705 6.96955 4.34837L8.38377 2.93416C9.26245 2.05548 10.6871 2.05548 11.5657 2.93416Z'
      fill='currentColor'
    />
    <path
      d='M3.43422 11.0658C2.55554 10.1872 2.55554 8.76254 3.43422 7.88386L3.73726 7.58082L2.6766 6.52016L2.37356 6.8232C0.909091 8.28767 0.909091 10.662 2.37356 12.1265C3.83802 13.591 6.21239 13.591 7.67686 12.1265L9.09107 10.7123C10.5555 9.24782 10.5555 6.87346 9.09107 5.40899L8.03041 6.46965C8.90909 7.34833 8.90909 8.77295 8.03041 9.65163L6.6162 11.0658C5.73752 11.9445 4.3129 11.9445 3.43422 11.0658Z'
      fill='currentColor'
    />
  </Svg>
);

Link14.displayName = 'Link14';
export default Link14;
